import {createSelector} from 'reselect';

export const selectFile = (state) => state.files;

export const makeSelectCreate = () =>
  createSelector(selectFile, (fileState) => ({
    submitting: fileState.submitting,
    createSuccess: fileState.createSuccess,
    createFailed: fileState.createFailed,
    createError: fileState.createError,
    created: fileState.created,
  }));
